import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { TailSpin } from 'react-loader-spinner';
import Overview from "./Reports/report-pdf/Overview";
import Snapshot from "./Reports/report-pdf/Snapshot";
import StarterQuardrant from "./Reports/report-pdf/StarterQuardrant";
import FourQuadrants from "./Reports/report-pdf/FourQuadrants";
import HeartStarterQuadrants from "./Reports/report-pdf/HeartStarterQuadrants";
import HeartToSoul from "./Reports/report-pdf/HeartToSoul";
import Soul from "./Reports/report-pdf/Soul";
import Mind from "./Reports/report-pdf/Mind";
import Strength from "./Reports/report-pdf/Strength";
import LeadershipChart from "./Reports/report-pdf/LeadershipChart";
import LeadershipStyle from "./Reports/report-pdf/LeadershipStyle";
import LeadershipStyle3 from "./Reports/report-pdf/LeadershipStyle3";
import LeadershipFlow from "./Reports/LeadershipFlow";
import Item from "./Reports/report-pdf/Item";
import ItemTwo from "./Reports/report-pdf/ItemTwo";
import CollabrativeInFocus from "./Reports/report-pdf/CollabrativeInFocus";
import VisionaryInFocus from "./Reports/report-pdf/VisionaryInFocus";
import StrategicInFocus from "./Reports/report-pdf/StrategicInFocus";
import PerformanceInFocus from "./Reports/report-pdf/PerformanceInFocus";
import AlignmentFlowFirst from "./Reports/report-pdf/AlignmentFlowFirst";
import AlignmentFlowSecond from "./Reports/report-pdf/AlignmentFlowSecond";
import Mindset from "./Reports/report-pdf/Mindset";
import ReflectAndIntegrate1 from "./Reports/report-pdf/ReflectAndIntegrate1";
import ReflectAndIntegrate2 from "./Reports/report-pdf/ReflectAndIntegrate2";
import ReflectAndIntegrate3 from "./Reports/report-pdf/ReflectAndIntegrate3";
import ReflectAndIntegrate4 from "./Reports/report-pdf/ReflectAndIntegrate4";
import Heart from "./Reports/report-pdf/Heart";
import QF_ItemOnePage from "./Reports/report-pdf/QF_ItemOnePage";
import QF_ItemTwoPage from "./Reports/report-pdf/QF_ItemTwoPage";
import QF_ItemThreePage from "./Reports/report-pdf/QF_ItemThreePage";
import YourQuardrantsFlow from "./Reports/report-pdf/YourQuardrantsFlow";
import CoverPage from "./Reports/report-pdf/CoverPage";
import TableContentPreview from "./Reports/report-pdf/TableContentPreview";
import HomeStarterQuadrantPreview from "./Reports/report-pdf/HomeStarterQuadrantPreview";
import HomeQuadrantFlow from "./Reports/report-pdf/HomeQuadrantFlow";
import HomeLeadershipStyle from "./Reports/report-pdf/HomeLeadershipStyle";
import LeadershipFlow2 from "./Reports/report-pdf/LeadershipFlow2";
import HomeMindset from "./Reports/report-pdf/HomeMindset";
import MindsetResult from "./Reports/report-pdf/MindsetResult";
import HomeReflectAndIntegrate from "./Reports/report-pdf/HomeReflectAndIntegrate";
import Mindset2 from "./Reports/report-pdf/Mindset2";
import AuthContext from "../../Context/AuthContext";
import GroupReportContext from "../../Context/GroupReportContext";
import MindsetResultSelf from "./Reports/report-pdf/MindestResultSelf";
import QuadrentFlowMeasure from "./Reports/report-pdf/QuadrentFlowMeasure";
import SnapShotResult from "./Reports/report-pdf/SnapShotResult";
import ItemThree from "./Reports/report-pdf/ItemThree";

const pageMapping = {
  "Cover Page": 1,
  "Table of Contents": 2,
  "Overview": 3,
  "Summary Snapshot": 4,
  "Quadrent Flow Measure": 5,
  "Snapshot Results": 6,
  "Starter Quadrant": 7,
  "Starter Quadrant Chart": 8,
  "Results": 9,
  "HomeQuadrantFlow": 10,
  "Introduction": 11,
  "Quadrant Flow": 12,
  "Items Overview Self": 13,
  "QFItemOnePage 1": 13,
  "QFItemTwoPage 2": 14,
  "QFItemThreePage 3": 15,
  "Quadrant In Focus": 16,
  "Heart": 16,
  "Soul": 17,
  "Mind": 18,
  "Strength": 19,
  "Home Leadership Style": 20,
  "Leadership Style Introduction": 21,
  "Leadership Style Results": 22,
  "Leadership Style Chart": 23,
  "Leadership Flow Introduction": 24,
  "Leadership Introduction": 24,
  "Leadership Flow Results": 25,
  "Items Overview Leadership Flow Self": 26,
  "Item 1": 26,
  "Item 2": 27,
  "Item 3": 28,
  "Leadership Style In Focus": 29,
  "Collaborative": 29,
  "Visionary": 30,
  "Strategic": 31,
  "Performance": 32,
  "Alignment": 33,
  "Alignment 1": 33,
  "Alignment 2": 34,
  "Home Mindset": 35,
  "Mindset Introduction": 36,
  "Mindset 1": 36,
  // "Mindset 2": 37,
  "Mindset Results": 37,
  "Home Reflect And Integrate": 38,
  "Reflect and Integrate": 39,
  "Life Integration": 40,
  "Leadership Integration": 41,
  "Final Thoughts": 42,
  // "Feedback Comparison": 38,
  // "Group Dynamics": 39
};

const reportSections = [
  "Cover Page",
  "Table of Contents",
  "Overview",
  "Summary Snapshot",
  "Quadrent Flow Measure",
  "Snapshot Results",
  "Starter Quadrant",
  //   "Four Quadrants",
  "Starter Quadrant Chart",
  "Results",
  "HomeQuadrantFlow",
  "Introduction",
  "Quadrant Flow",
  "Items Overview Self",
  "QFItemOnePage 1",
  "QFItemTwoPage 2",
  "QFItemThreePage 3",
  "Quadrant In Focus",
  "Heart",
  "Soul",
  "Mind",
  "Strength",
  "Home Leadership Style",
  "Leadership Style Introduction",
  "Leadership Style Results",
  "Leadership Style Chart",
  "Leadership Flow Introduction",
  "Leadership Introduction",
  "Leadership Flow Results",
  "Items Overview Leadership Flow Self",
  "Item 1",
  "Item 2",
  "Item 3",
  "Leadership Style In Focus",
  "Collaborative",
  "Visionary",
  "Strategic",
  "Performance",
  "Alignment",
  "Alignment 1",
  "Alignment 2",
  "Home Mindset",
  "Mindset Introduction",
  "Mindset 1",
  // "Mindset 2",
  "Mindset Results",
  "Home Reflect And Integrate",
  "Reflect and Integrate",
  "Life Integration",
  "Leadership Integration",
  "Final Thoughts",
  //   "Feedback Comparison",
  //   "Group Dynamics"
];

const formatDate = (dateStr) => {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  const day = date.getDate();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
};

export default function SelfReportPreview({ activeSubMenu, activeMenu, apiData, menuItems, reportDataName, previewData }) {
  const [localData, setLocalData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const sectionRefs = useRef({});
  const groupContext = useContext(GroupReportContext);
  // The Starter Quadrant and Leadership Style pie charts read the self scores
  // from the context, so the pages must not paint before those are hydrated.
  const hasSelfScores = groupContext?.averagePercentagesSelf?.length > 0
    && groupContext?.averagePercentagesLeadershipSelf?.length > 0;
  const [clientName, setClientName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [createdgroup360Date, setCreatedgroup360Date] = useState("");
  const [teamMemberCount, setTeamMemberCount] = useState(0);
  const selectedReport = groupContext?.selectedReport;
  const teamName = selectedReport?.teamName || "";
  const groupData = selectedReport;

  // Define the report type for Self reports
  const reportType = "SELF REPORT";

  useEffect(() => {
    const currentSection = activeSubMenu || activeMenu;
    const el = sectionRefs.current[currentSection];
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [activeMenu, activeSubMenu]);

  useEffect(() => {

    if (reportType === "GROUP REPORT") {
      if (groupData && (groupData.teamname || groupData.assessment_hash) && teamName) {
        setIsLoading(false);
      }
    } else if (apiData && (apiData.fullName || apiData.clientData) && hasSelfScores) {
      setIsLoading(false);
    }

  }, [apiData, previewData, groupContext, groupData, reportType, hasSelfScores])

  useEffect(() => {


    if (teamName) {
      setClientName(teamName);
    }

    if (apiData?.clientData?.organizationName) {
      setCompanyName(apiData.clientData.organizationName);
    }
    if (apiData?.lastAsmtCompletedAt) {
      setCreatedDate(formatDate(apiData.lastAsmtCompletedAt));
    }

    if (!companyName || !createdDate) {
      const clientData = localStorage.getItem("clientData");
      if (clientData) {
        const parsedData = JSON.parse(clientData);
        if (!companyName) setCompanyName(parsedData?.company || "Company Name");
        if (!createdDate)
          setCreatedDate(formatDate(parsedData?.lastAsmtCompletedAt) || "Created Date");
      }
    }
  }, [previewData, apiData, teamName]);

  useEffect(() => {
    const rawDate =
      reportType === "SELF REPORT"
        ? groupContext?.currentTeamData?.results[0]?.completionDate ?? groupContext?.currentTeamData?.results[0]?.completionDate
        : groupContext?.selectedReport?.createdDate ?? groupContext?.currentTeamData?.createdDate;

    const reportDate = rawDate
      ? new Date(rawDate).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      })
      : undefined;

    console.log(reportDate)
    setCreatedgroup360Date(reportDate);
  }, [groupContext, reportType]);

  const headerData = useMemo(() => {
    const resolvedRespondent = apiData?.fullName || clientName;
    const resolvedCompany =
      apiData?.clientData?.organizationName || apiData?.companyName || companyName;
    const resolvedDate =
      createdDate || (apiData?.lastAsmtCompletedAt ? formatDate(apiData.lastAsmtCompletedAt) : "");
    const resolvedCompletionDate = createdgroup360Date || resolvedDate;
    const resolvedReportName = reportDataName || resolvedRespondent;

    return {
      respondentName: resolvedRespondent,
      companyName: resolvedCompany,
      date: resolvedDate,
      reportDataName: resolvedReportName,
      completionDate: resolvedCompletionDate,
    };
  }, [
    apiData?.fullName,
    apiData?.clientData?.organizationName,
    apiData?.companyName,
    apiData?.lastAsmtCompletedAt,
    clientName,
    companyName,
    createdDate,
    createdgroup360Date,
    reportDataName,
  ]);

  useEffect(() => {
    const hasValue = Object.values(headerData).some(Boolean);
    if (hasValue) {
      sessionStorage.setItem("selfReportHeaderData", JSON.stringify(headerData));
    }
  }, [headerData]);



  useEffect(() => {
    const storageKey = `selfReportData-${activeMenu || activeSubMenu}`;

    if (apiData && Object.keys(apiData).length > 0) {
      setLocalData(apiData);
      setIsLoading(!hasSelfScores);
    } else {
      setIsLoading(true);
    }
  }, [apiData, activeMenu, activeSubMenu, hasSelfScores]);

  // const getCurrentPageNumber = () => {
  //     const currentSection = activeSubMenu || activeMenu;
  //     return pageMapping[currentSection] || 1;
  // };

  const renderCommonContent = (sectionName, data, pageNumber) => {
    // console.log("data", data)
    // const data = localData || apiData;
    // const currentPageNumber = getCurrentPageNumber();
    // Helper to get page number for a section
    const getPageNumber = (sectionKey) => pageMapping[sectionKey] || 1;

    switch (sectionName) {
      case "Cover Page":
        return <CoverPage name={data?.fullName} apiData={data} pageNumber={pageNumber} reportType={reportType} reportDataName={reportDataName} previewData={previewData} />;
      case "Table of Contents": {
        // Define the TOC sections and their keys as used in the report
        const tocSections = [
          { label: "OVERVIEW", key: "Overview" },
          { label: "SNAPSHOT", key: "Snapshot Results" },
          { label: "STARTER QUADRANT", key: "Starter Quadrant" },
          { label: "QUADRANT FLOW", key: "HomeQuadrantFlow" },
          { label: "LEADERSHIP STYLE", key: "Home Leadership Style" },
          { label: "LEADERSHIP FLOW	", key: "Leadership Flow Introduction" },
          { label: "GAP ANALYSIS", key: "Alignment" },
          { label: "MINDSET", key: "Home Mindset" },
          { label: "REFLECTIONS", key: "Home Reflect And Integrate" },
        ];
        const tocPageNumbers = tocSections.map(section => getPageNumber(section.key));
        return <TableContentPreview
          menuItems={menuItems}
          reportType={reportType}
          pageNumber={pageNumber}
          tocSections={tocSections}
          tocPageNumbers={tocPageNumbers}
          apiData={data}
        />;
      }
      case "Overview":
        return <Overview apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Summary Snapshot":
        return <Snapshot apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Quadrent Flow Measure":
        return <QuadrentFlowMeasure apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Snapshot Results":
        return <SnapShotResult apiData={data} pageNumber={pageNumber} reportType={reportType} previewData={previewData} />;
      case "Starter Quadrant":
        return <HomeStarterQuadrantPreview apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      // case "Four Quadrants":
      //     return <FourQuadrants apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Starter Quadrant Chart":
        return <StarterQuardrant apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Results":
        return <HeartStarterQuadrants apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      //Quadrant Flow
      case "HomeQuadrantFlow":
        return <HomeQuadrantFlow apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Introduction":
        return <YourQuardrantsFlow apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Quadrant Flow":
        return <HeartToSoul apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Items Overview Self":
      case "QFItemOnePage 1":
        return <QF_ItemOnePage apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "QFItemTwoPage 2":
        return <QF_ItemTwoPage apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "QFItemThreePage 3":
        return <QF_ItemThreePage apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Quadrant In Focus":
      case "Heart":
        return <Heart apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Soul":
        return <Soul apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Mind":
        return <Mind apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Strength":
        return <Strength apiData={data} pageNumber={pageNumber} reportType={reportType} />;

      //Leadership Style
      case "Home Leadership Style":
        return <HomeLeadershipStyle apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Leadership Style Introduction":
        return <LeadershipStyle apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Leadership Style Results":
        return <LeadershipStyle3 apiData={data} pageNumber={pageNumber} reportType={reportType} />;
            case "Leadership Style Chart":
        return <LeadershipChart apiData={data} pageNumber={pageNumber} reportType={reportType} />;

      //Leadership Flow

      case "Leadership Flow Introduction":
      case "Leadership Introduction":
        return <LeadershipFlow apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Leadership Flow Results":
        return <LeadershipFlow2 apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Items Overview Leadership Flow Self":
      case "Item 1":
        return <Item apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Item 2":
        return <ItemTwo apiData={data} pageNumber={pageNumber} reportType={reportType} />;
        case "Item 3":
        return <ItemThree apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Leadership Style In Focus":
      case "Collaborative":
        return <CollabrativeInFocus apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Visionary":
        return <VisionaryInFocus apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Strategic":
        return <StrategicInFocus apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Performance":
        return <PerformanceInFocus apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Alignment":
      case "Alignment 1":
        return <AlignmentFlowFirst apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Alignment 2":
        return <AlignmentFlowSecond apiData={data} pageNumber={pageNumber} reportType={reportType} />

      //Mindset
      case "Home Mindset":
        return <HomeMindset apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Mindset Introduction":
      case "Mindset 1":
        return <Mindset apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      // case "Mindset 2":
      //   return <Mindset2 apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Mindset Results":
        return <MindsetResultSelf apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      //Reflect and Integrate
      case "Home Reflect And Integrate":
        return <HomeReflectAndIntegrate apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Reflect and Integrate":
        return <ReflectAndIntegrate1 apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Life Integration":
        return <ReflectAndIntegrate2 apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Leadership Integration":
        return <ReflectAndIntegrate3 apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      case "Final Thoughts":
        return <ReflectAndIntegrate4 apiData={data} pageNumber={pageNumber} reportType={reportType} />;
      // // 360-specific section
      // case "Feedback Comparison":
      //     return <div>Feedback Comparison Content for 360 Report</div>;
      // // Group-specific section
      // case "Group Dynamics":
      //     return <div>Group Dynamics Content for Group Report</div>;
      // default:
      //     return <p>Select a section</p>;
    }
  };

  const renderAllSections = () => {
    const data = localData || apiData;
    const currentSection = activeSubMenu || activeMenu;
    const currentPageNumber = pageMapping[currentSection];
    const renderedPages = new Set();
    return reportSections.map((sectionName, index) => {
      const pageNumber = pageMapping[sectionName] || index + 1;
      // If this is not the active section, and another section for this page number exists and is active, skip rendering
      if (
        pageNumber === currentPageNumber &&
        sectionName !== currentSection
      ) {
        return null;
      }
      if (renderedPages.has(pageNumber)) {
        return null;
      }
      renderedPages.add(pageNumber);
      const className = sectionName?.toLowerCase().replace(' ', '-');
      return (
        <div
          key={sectionName}
          className={className}
          ref={(el) => (sectionRefs.current[sectionName] = el)}
          style={{ marginBottom: "40px", background: "#fff", width: "612px", height: "792px", position: 'relative', padding: "36px 72px", boxSizing: "border-box" }}
        >
          {renderCommonContent(sectionName, data, pageNumber)}
        </div>
      );
    });
  };

  return (
    <div>
      {isLoading && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: "#fff",
          position: 'relative',
          marginBottom: "40px", background: "#fff", width: "612px", height: "792px" , boxSizing: "border-box"
        }}>
          <TailSpin
            height="60"
            width="60"
            color="#007bff"
            ariaLabel="loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      )}
      {!isLoading && renderAllSections()}
    </div>
  );
}
